import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type ReqStatusKind = 'entwurf' | 'in-bearbeitung' | 'im-review' | 'freigegeben' | 'abgeschlossen';

@Component({
  selector: 'app-req-status-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="req-status-pill" [attr.data-kind]="kind()" data-testid="req-status-pill">
      <span class="req-status-pill__dot" aria-hidden="true"></span>
      {{ label() }}
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .req-status-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.4375rem;
      padding: 0.3125rem 0.6875rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      white-space: nowrap;
      background: var(--to-slate-bg);
      color: var(--to-slate-fg);

      &[data-kind='in-bearbeitung'] {
        background: var(--to-warn-bg);
        color: var(--to-warn-fg);
      }
      &[data-kind='im-review'] {
        background: var(--to-blue-bg);
        color: var(--to-blue-fg);
      }
      &[data-kind='freigegeben'] {
        background: var(--to-green-bg);
        color: var(--to-green-fg);
      }
      &[data-kind='abgeschlossen'] {
        background: var(--to-purple-bg);
        color: var(--to-purple-fg);
      }
    }

    .req-status-pill__dot {
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
      flex-shrink: 0;
      background: var(--to-slate-dot);

      .req-status-pill[data-kind='in-bearbeitung'] & {
        background: var(--to-warn-dot);
      }
      .req-status-pill[data-kind='im-review'] & {
        background: var(--to-blue-dot);
      }
      .req-status-pill[data-kind='freigegeben'] & {
        background: var(--to-green-dot);
      }
      .req-status-pill[data-kind='abgeschlossen'] & {
        background: var(--to-purple-dot);
      }
    }
  `,
})
export class ReqStatusPillComponent {
  readonly kind = input.required<ReqStatusKind>();
  readonly label = input.required<string>();
}
